import React, { useCallback } from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useInventoryPermissions } from '../../../../../hooks/useInventoryPermissions';
import { useRowConfig } from '../../../../../hooks/useRowConfig';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { RowBase } from '../../../../Table/RowBase/RowBase';
import type { InventoryValue } from '../../../inventoryStatusUtils';
import { getStatusInfo } from '../../../inventoryStatusUtils';

const RoomDiscountPriceRowComponent: React.FC<{ roomId: number }> = ({
  roomId,
}) => {
  const { inventoryRooms, onDuplicate, formatter } = useRowConfig({
    entityId: roomId,
    entityType: InventoryTabItemName.Rooms,
    fieldName: 'discountPrice',
    formatterName: 'discountPrice',
  });
  const { canEditDiscountPrice } = useInventoryPermissions();

  const handleGetStatusInfo = useCallback(
    (values: InventoryValue) => getStatusInfo(values as RoomOpeningInventory),
    []
  );

  if (!inventoryRooms) {
    return null;
  }

  return (
    <RowBase
      label="Room revenue share"
      hasInfoIcon
      tooltipTitle="Part of your package attributed to the room. For internal revenue use, not displayed to guests."
      entityId={roomId}
      fieldName="discountPrice"
      entityType={InventoryTabItemName.Rooms}
      getStatusInfo={handleGetStatusInfo}
      onDuplicate={onDuplicate}
      isEditable={canEditDiscountPrice}
      formatter={formatter}
    />
  );
};

export const RoomDiscountPriceRow = React.memo(RoomDiscountPriceRowComponent);
